import React from 'react';
import { CheckIcon, DropletIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-accent/20 bg-surface/40 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0bxfdwzqiu">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15ckg2l9o5u77">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-60" data-mp="1jcv8hsqmnguh">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed8wtnqg68ns">
            <DropletIcon className="h-8 w-8 shrink-0 text-accent drop-shadow-glow" aria-hidden="true" data-id="element-62" data-mp="1t2ol8x2ia20b" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-highlight sm:text-2xl" data-id="element-63" data-mp="1o56ad14xhcpo">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="1x51pfh1ltruz">
          Creata per docenti di scuola secondaria, istituti tecnici e università.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s4pe1ueleodj">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-66" data-mp="x5v7xvjzohon">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="16503qu461wx4">
              <CheckIcon className="h-4 w-4 text-accent drop-shadow-glow" aria-hidden="true" data-id="element-68" data-mp="162m8ol9hkkpk" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}